import { GET_AGENT_LOGS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

const getAgentLogsQueryKey = (
  agentId: string,
  account: string,
  month: string,
  year: string,
  offset?: number
) => ['agent-logs', agentId, account, month, year, offset];

interface Break {
  type: 'Lunch' | 'Meeting' | 'Training' | 'Idle' | 'Tech Issue';
  startedAt: string;
  endedAt: string;
  duration: number;
}

interface Deviation {
  type: 'START_EARLY' | 'START_LATE' | 'END_EARLY' | 'END_LATE';
  actualTime: string;
  scheduledTime: string;
  reason?: string;
}

interface AgentLog {
  _id: string;
  kimId: string;
  shiftId?: string;
  assignedTo: string;
  startTime: string;
  stopTime: string;
  duration: number;
  idleTime?: number;
  status: string;
  breaks?: Break[];
  deviations?: Deviation[];
  fileKeys?: string[];
  createdAt: string;
  updatedAt: string;
  timeZone?: string;
}

const getAgentLogs = async (
  agentId: string,
  account: string,
  month: string,
  year: string,
  offset?: number
): Promise<{
  success: boolean;
  data?: AgentLog[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(
      GET_AGENT_LOGS(agentId, account, month, year, offset)
    );

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getAgentLogs, type AgentLog, getAgentLogsQueryKey };
